import React from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  center?: boolean;
  light?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  center = false,
  light = false,
}) => {
  return (
    <div className={`mb-12 ${center ? 'text-center' : ''}`}>
      <h2 className={`text-3xl md:text-4xl font-bold mb-4 relative inline-block ${light ? 'text-white' : 'text-primary'}`}>
        {title}
        <span className={`absolute bottom-0 left-0 w-full h-1 mt-2 ${center ? 'left-0 right-0 mx-auto' : ''} ${light ? 'bg-white' : 'bg-primary'}`} style={{ bottom: '-8px', width: center ? '80px' : '100%', maxWidth: '100%' }}></span>
      </h2>
      {subtitle && (
        <p className={`text-lg mt-6 ${light ? 'text-gray-200' : 'text-secondary'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;